export const MAIN_WORKSPACE_NAVIGATION = [
  {
    section: "Workspace",
    items: [
      {
        label: "Dashboard",
        icon: "⌂"
      },
      {
        label: "Copilot",
        icon: "✨",
        requiredPlans: ["pro", "enterprise"],
        upgradeBadge: "PRO"
      }
    ]
  },
  {
    section: "ESG Reporting",
    items: [
      {
        label: "Reports",
        icon: "▤"
      },
      {
        label: "AI Draft",
        icon: "✦"
      },
      {
        label: "Materiality",
        icon: "◎"
      },
      {
        label: "Analytics",
        icon: "▥"
      }
    ]
  },
  {
    section: "Document Intelligence",
    items: [
      {
        label: "Document Intelligence",
        icon: "▧"
      },
      {
        label: "Evidence Library",
        icon: "✓"
      }
    ]
  },
  {
    section: "Customer Success",
    items: [
      {
        label: "Customer Dashboard",
        icon: "◫",
        roles: [
          "super_admin",
          "admin",
          "customer_success",
          "consultant"
        ]
      }
    ]
  },
  {
    section: "Sales CRM",
    items: [
      {
        label: "Leads CRM",
        icon: "◇",
        roles: [
          "super_admin",
          "admin",
          "sales",
          "customer_success",
          "consultant"
        ]
      },
      {
        label: "Follow-Ups",
        icon: "↗",
        roles: [
          "super_admin",
          "admin",
          "sales",
          "customer_success",
          "consultant"
        ]
      }
    ]
  },
  {
    section: "Account",
    items: [
      {
        label: "Subscription",
        icon: "▣"
      },
      {
        label: "Admin",
        icon: "⚙",
        roles: ["super_admin"]
      }
    ]
  }
];

function normalizeRole(role) {
  const normalized = String(role || "preparer")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  if (normalized === "superadmin") {
    return "super_admin";
  }

  if (normalized === "customersuccess") {
    return "customer_success";
  }

  return normalized;
}

function canSeeItem(item, normalizedRole) {
  if (!Array.isArray(item.roles) || item.roles.length === 0) {
    return true;
  }

  return item.roles
    .map(normalizeRole)
    .includes(normalizedRole);
}

export function getVisibleWorkspaceNavigation(userRole = "preparer") {
  const normalizedRole = normalizeRole(userRole);

  return MAIN_WORKSPACE_NAVIGATION
    .map((group) => ({
      ...group,
      items: group.items.filter((item) =>
        canSeeItem(item, normalizedRole)
      )
    }))
    .filter((group) => group.items.length > 0);
}